/**
 * Upload de imagens para o geocoder (FastAPI), exposto em /geo/v1/uploads.
 * Devolve a URL pública (/geo/v1/uploads/devices/<arquivo>) para salvar em device.photo.
 */

export interface UploadResult {
  filename: string;
  url: string;
}

export const uploadsApi = {
  devicePhoto: async (file: File): Promise<UploadResult> => {
    const fd = new FormData();
    fd.append('file', file);
    const r = await fetch('/geo/v1/uploads/device-photo', {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
    if (!r.ok) {
      let detail = `${r.status}`;
      try {
        const j = await r.json();
        if (j?.detail) detail = j.detail;
      } catch {
        /* ignore */
      }
      throw new Error(detail);
    }
    return r.json() as Promise<UploadResult>;
  },
};
